import { render, staticRenderFns } from "./CompetencesSelector.vue?vue&type=template&id=388dbff8&scoped=true&"
import script from "./CompetencesSelector.vue?vue&type=script&lang=js&"
export * from "./CompetencesSelector.vue?vue&type=script&lang=js&"
import style0 from "./CompetencesSelector.vue?vue&type=style&index=0&id=388dbff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388dbff8",
  null
  
)

export default component.exports